@for (item of filterOptions | async; track item) {
  <div>
    <div class="form-group">
      @if (item.text) {
        <label>{{item.text | translate}}</label>
      }
      <app-custom-date-time-picker [dateTime]="item.value"
        (dateTimeEmit)="onChange($event,item)">
      </app-custom-date-time-picker>
    </div>
  </div>
}
